import ReactDOM from "react-dom";
import { Sql, getSqlValue } from "./Sql";
import { Alert } from "./Alert.js";
import { Zql, getZqlValue } from "./Zql.js";
import './css/index.css';

const copyZql = () => {
  var input = document.createElement("textarea");
  input.value = getZqlValue();
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);

  ReactDOM.render(< Alert type="success" message="Copy completed successfully" />, document.getElementById('alert'));
  window.setTimeout(() => {
    ReactDOM.render(<></>, document.getElementById('alert'));
  }, 3000);
}

const copySql = () => {
  var input = document.createElement("textarea");
  input.value = getSqlValue();
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);

  ReactDOM.render(< Alert type="success" message="Copy completed successfully" />, document.getElementById('alert'));
  window.setTimeout(() => {
    ReactDOM.render(<></>, document.getElementById('alert'));
  }, 3000);
}

ReactDOM.render(<Sql />, document.getElementById('sql'));
ReactDOM.render(<Zql value={getZqlValue()} />, document.getElementById('zql'));
ReactDOM.render(<input className="btn btn-light btnColor" onClick={copyZql} type="button" value="Copy ZQL" />, document.getElementById('copy_zql'));
ReactDOM.render(<input className="btn btn-light btnColor" onClick={copySql} type="button" value="Copy beautiful SQL" />, document.getElementById('copy_sql'));
